import type * as Types from 'app/types/graphql';

import { VariantProductVariantSelectFragmentDoc } from '../fragments/variantProductVariant.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantProductVariantsBulkSetMutationVariables = Types.Exact<{
  variantID: Types.Scalars['ID']['input'];
  input: Array<Types.SetVariantProductVariantInput>;
}>;

export type VariantProductVariantsBulkSetMutationResponse = {
  variantProductVariantsBulkSet: Array<
    Pick<
      Types.VariantProductVariant,
      'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
    >
  >;
};

export const VariantProductVariantsBulkSetDocument = `
    mutation VariantProductVariantsBulkSet($variantID: ID!, $input: [SetVariantProductVariantInput!]!) {
  variantProductVariantsBulkSet(variantID: $variantID, input: $input) {
    ...VariantProductVariantSelect
  }
}
    ${VariantProductVariantSelectFragmentDoc}`;

export const useVariantProductVariantsBulkSetMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantProductVariantsBulkSetMutationResponse,
    TError,
    VariantProductVariantsBulkSetMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantProductVariantsBulkSetMutationResponse,
    TError,
    VariantProductVariantsBulkSetMutationVariables,
    TContext
  >(
    ['VariantProductVariantsBulkSet'],
    (variables?: VariantProductVariantsBulkSetMutationVariables) =>
      appFetcher<
        VariantProductVariantsBulkSetMutationResponse,
        VariantProductVariantsBulkSetMutationVariables
      >(VariantProductVariantsBulkSetDocument, variables)(),
    options,
  );
};

useVariantProductVariantsBulkSetMutation.getKey = () => ['VariantProductVariantsBulkSet'];
